
<div class="progress-area container" *ngIf="!mobile" style="margin-bottom: 5%">
  <div class="columns is-mobile">
    <div class="column is-one-third progress-area-box">
      <img alt="Box" src="assets/images/prozessleiste_Icon/box.png"
           class="progress-area-first">
      <h3 class="progress-area-title-active">1. PRODUKTAUSWAHL / OBJEKTDATEN</h3>
    </div>

    <div class="column is-one-third progress-area-box">
      <img alt="Approve Invoice" src="assets/images/prozessleiste_Icon/approve-invoice.png"
           class="progres-area-img progress-area-third is-inactive">
      <h3 class="progress-area-title-inactive">2. VOLLMACHT </h3>
    </div>
    <div class="column is-one-third progress-area-box">
      <img alt="List" src="assets/images/prozessleiste_Icon/list.png"
           class="progres-area-img progress-area-second is-inactive">
      <h3 class="progress-area-title-inactive">3. ZUSAMMENFASSUNG / BESTELLABSCHLUSS</h3>
    </div>

  </div>
  <progress class="progress is-small" value="{{value}}" max="100">{{value}}%</progress>

</div>
